export default "__VITE_ASSET__CkOEyAzv__"